export const isTelegramView = () => {
  const route = useRoute()

  const chatId = route.query.telegram_chat_id as string | undefined

  return !!chatId
}

export const isVkView = () => {
  const route = useRoute()

  const vkUserId = route.query.vk_user_id as string | undefined

  return !!vkUserId
}
